// extracted by mini-css-extract-plugin
export default {"CardHeader":"CardHeader_CardHeader__okV3k"};